import { IMessage } from "../features/OpenAI/types";
import { convertToIndexedDbName } from "../utils/converter";

import { openDB } from 'idb';

async function initChatDB(boschID: string) {
    return await openDB(`${boschID}-chat-store`, 1, {
        upgrade(db) {
            db.createObjectStore("messages", { keyPath: "id", autoIncrement: true });
        }
    });
}

export const saveMessage = async (boschID: string, message: IMessage) => {
    const db = await initChatDB(boschID);
    const timestamp = Date.now();
    await db.add('messages', { ...message, timestamp });
};

export async function getAllMessages(boschID: string) {
    const allMessages = (await initChatDB(boschID)).getAll('messages');
    return (await allMessages).map(m => {
        return {
            content: m.content,
            time: m.time, // Convert timestamp to readable format
            isMe: m.isMe,
            refs: m.refs
        } as IMessage;
    }
    );
}

export enum DBPrefix {
    DB_USERS_PREFIX = "mgt-users-",
    DB_RESPONSES_PREFIX = "mgt-responses-",
}

let db: IDBDatabase | null = null;

export function openMgtDb(dbSuffix: string, dbPrefix: DBPrefix): Promise<IDBDatabase> {
    return new Promise((resolve, reject) => {
        if (db) return resolve(db);
        const dbName = `${dbPrefix}${dbSuffix}`;
        const storeName = dbPrefix === DBPrefix.DB_RESPONSES_PREFIX ? "responses" : "users";
        const request = indexedDB.open(dbName);

        request.onupgradeneeded = (event) => {
            const db = (event.target as IDBOpenDBRequest).result;
            if (!db.objectStoreNames.contains(storeName)) {
                db.createObjectStore(storeName);
            }
        };

        request.onsuccess = () => {
            db = request.result;
            resolve(db);
        };

        request.onerror = () => reject(request.error);
    });
}

// user key has format :"uib80001@bosch.com"
export async function getCacheUser(userId: string, key: string): Promise<any | null> {
    const db = await openMgtDb(convertToIndexedDbName(userId), DBPrefix.DB_USERS_PREFIX);
    return new Promise((resolve, reject) => {
        const tx = db.transaction("users", "readonly");
        const store = tx.objectStore("users");
        const request = store.get(key);
        request.onsuccess = () => resolve(request.result?.user || null);
        request.onerror = () => reject(request.error);
    });
}

// group key has format: v1.0/groups/{groupId}
export async function getCacheGroup(userId: string, key: string): Promise<any | null> {
    const db = await openMgtDb(convertToIndexedDbName(userId), DBPrefix.DB_RESPONSES_PREFIX);
    return new Promise((resolve, reject) => {
        const tx = db.transaction("responses", "readonly");
        const store = tx.objectStore("responses");
        const request = store.get(`v1.0/groups/${key}`);
        console.log(request, key);
        request.onsuccess = () => resolve(request.result?.response || null);
        request.onerror = () => reject(request.error);
    });
}
